import "./IronCondorIdeaInfoDialogComponent.scss";
import {IComponentOptions, IOnDestroy, IOnInit} from "angular";
import {ReplaySubject} from "rxjs";

export const IronCondorIdeaInfoDialog = "tfIronCondorIdeaInfoDialog";

export function ironCondorIdeaInfoDialog(parentDir: string): IComponentOptions {
    return {
        templateUrl: `${parentDir}/info/iron-condor/dialog/IronCondorIdeaInfoDialogComponent.html`,
        bindings: {
            model: "<",
            modalInstance: "<"
        },
        controllerAs: "ctrl",
        controller: IronCondorIdeaInfoDialogComponent
    };
}

export class IronCondorIdeaInfoDialogComponent implements IOnInit, IOnDestroy {

    private readonly destroyed$ = new ReplaySubject<boolean>(1);

    /** @ngInject */
    public constructor() {

    }

    public $onInit(): void {
    }

    public $onDestroy(): void {
        this.destroyed$.next(true);
        this.destroyed$.complete();
    }
}
